import React from 'react';
// template components
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import financialPlanningImageWebp from './images/total-invested-assets-graph.webp';
// styles
import {
  ColStyledLeft,
  ColStyledRight,
  DivStyledMobileImageContainer,
  FigCaptionStyled,
  FigureStyled,
  PictureStyled,
  TypographyStyled,
} from './styles';

const getFinancialPlanningImage = () => {
  return (
    <FigureStyled role='group'>
      <PictureStyled
        lazyLoad={false}
        variant='rectangular'
        src={financialPlanningImageWebp}
        altText='Bar chart showing total invested assets and the compound annual growth rate for the last ten years.'
        fullWidth={false}
      />
      <FigCaptionStyled className='nmx-assistive-text'>
        <h2>Total invested assets</h2>
        <p>Bar chart showing total invested assets and the 5.2 percent compound annual growth rate over the last ten years.</p>
        <h2>Values</h2>
        <table>
          <caption>Growth rate by year: Includes investment income due and accrued</caption>
          <tbody>
            <tr>
              <td>2014</td>
              <td>2015</td>
              <td>2016</td>
              <td>2017</td>
              <td>2018</td>
              <td>2019</td>
              <td>2020</td>
              <td>2021</td>
              <td>2022</td>
              <td>2023</td>
            </tr>
            <tr>
              <td>196.9 billion dollars</td>
              <td>205.4 billion dollars</td>
              <td>215.5 billion dollars</td>
              <td>227.4 billion dollars</td>
              <td>236.6 billion dollars</td>
              <td>250.3 billion dollars</td>
              <td>264.3 billion dollars</td>
              <td>286.5 billion dollars</td>
              <td>299 billion dollars</td>
              <td>309.7 billion dollars</td>
            </tr>
          </tbody>
        </table>
      </FigCaptionStyled>
    </FigureStyled>
  );
};

export default () => {
  return (
    <SectionContainer
      id='financial-information-backing-our-strength'
      disableBottomPadding>
      <Row align='center'>
        <ColStyledLeft medium={6}>
          <TypographyStyled component='h3'>
            Backing our strength&#8212;Northwestern Mutual&#39;s investment portfolio
          </TypographyStyled>
          {/* ONLY DISPLAY FOR MOBILE */}
          <DivStyledMobileImageContainer>
            {getFinancialPlanningImage()}
          </DivStyledMobileImageContainer>
          <Typography disableBottomPadding>
            Northwestern Mutual invests the majority of its assets through the General Account, the company&#39;s &#36;310&#43; billion portfolio. The portfolio has grown consistently year after year. By buying life insurance, disability insurance and deferred annuities, clients immediately gain the opportunity to share in the company&#39;s favorable results.
          </Typography>
        </ColStyledLeft>
        {/* ONLY DISPLAY FOR TABLET AND DESKTOP */}
        <ColStyledRight
          xsmall={0}
          medium={6}>
          {getFinancialPlanningImage()}
        </ColStyledRight>
      </Row>
    </SectionContainer>
  );
};
